var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FlotoCrudContainer',{attrs:{"as-table":"","fetch-fn":_vm.getScenarios,"columns":_vm.tableColumns},scopedSlots:_vm._u([{key:"actions",fn:function(ref){
var item = ref.item;
return [_c('td',{class:{ 'hover-action-container': _vm.hoverableActions }},[_vm._t("action",null,{"item":item})],2)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }